import React, { useState, useRef, useCallback } from "react";
import { DebounceInput } from 'react-debounce-input';
import { GameSearchResults } from '../Game/GameSearchResults.jsx';

function SearchOverlay(props) {
    const [searchValue, setSearchValue] = useState('');
    const searchInputRef = useRef(null);

    const focusOnMount = useCallback(function (input) {
        if (input != null && searchInputRef.current !== input) {
            try {
                if (props.showSearchFocus) {
                    input.focus();
                } else {
                    input.blur();
                }
            } catch (e) { /* iOS može baciti ako input nije u DOM-u */ }
        }
        searchInputRef.current = input;
    }, [props.showSearchFocus]);

    function handleSearchChanged(event) {
        props.refreshRandomGameFn(false);
        setSearchValue(event.target.value);
    }

    function handleSearchChange(value) {
        props.refreshRandomGameFn(false);
        setSearchValue(value);
    }

    function handleClose() {
        props.showSearchFn(false);
        setSearchValue('');
    }

    if (!props.showSearch) return null;

    return (
        <section className="search-overlay">
            <div className="search-overlay-header">
                <DebounceInput
                    minLength={2}
                    id="search-input"
                    debounceTimeout={600}
                    className="search-overlay-input"
                    type="text"
                    autoComplete="off"
                    placeholder="Upiši naziv igre ili temu"
                    onChange={handleSearchChanged}
                    inputRef={focusOnMount}
                    value={searchValue}
                />
                <a className="search-overlay-close" onClick={handleClose}>
                    <span className="icon ico-close"></span>
                </a>
            </div>
            <div className="search-results" onTouchStart={() => { try { if (searchInputRef.current) searchInputRef.current.blur(); } catch (e) {} }}>
                <div className="max-width-100 clearfix">
                    <GameSearchResults
                        brands={props.brands}
                        onSearchChange={handleSearchChange}
                        routePrefix=""
                        {...props}
                        searchValue={searchValue}
                    />
                </div>
            </div>
        </section>
    );
}

export default SearchOverlay;
